import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls"

const ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "PlantIQ"
})

export default createPersistedState({
  //TODO  storage: ls,
  // storage: {
  //   getItem: key => ls.get(key),
  //   setItem: (key, value) => ls.set(key, value),
  //   removeItem: key => ls.remove(key)
  // },
  paths: ["projectPre.currentProject", "app.language", "auth.userInfo", "system.cityList", "system.regionList", "system.zoneList", "system.customizedLib", "auth.showWelcome"],
  filter: mutation => !mutation.type.startsWith("auth/") || mutation.type === "auth/SET_USER_INFO"
})



// WEBPACK FOOTER //
// ./src/store/plugins/persistence.js